import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { isLabTierUpgradeCampaignPayload } from 'loyalty/tierUpgradeCampaign/tierUpgradeCampaignTypes'

/** Every enabled tier upgrade campaign configured in the `enableTierUpgradeCampaign` Lab flag. */
function useTierUpgradeCampaigns(): Array<App.TierUpgradeCampaignPayload> {
  const flag = useLabFeatureFlag(LabFeatureFlags.enableTierUpgradeCampaign)

  return useMemo(() => {
    const campaigns: Array<App.TierUpgradeCampaignPayload> = []

    if (!flag?.enabled) return campaigns

    // Legacy format: flag.value is the campaign payload directly
    if (!Array.isArray(flag.value)) {
      if (isLabTierUpgradeCampaignPayload(flag.value)) campaigns.push(flag.value)
      return campaigns
    }

    // New format: flag.value is an array of campaign entries
    for (const entry of flag.value) {
      if (entry?.enabled && isLabTierUpgradeCampaignPayload(entry.value)) campaigns.push(entry.value)
    }
    return campaigns
  }, [flag])
}

export default useTierUpgradeCampaigns
